module.exports = __webpack_public_path__ + "components/media-kit/static/icon-na-30a354c536530b1d6423c76880f7711a.svg";